import React from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectCategoryIds, setNewParams, setReorderIds } from "../../../../store/sticker_maker/categoriesSlice";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo, { parentInterface } from "../../../../componets/NavBarTwo";
import NavBarThree from "../../../../componets/NavBarThree";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";

interface PropsInterface {
  title: string;
  navs: {[index: number]: any};
  parent?: parentInterface;
}

const _PageHeader = ({ title, navs, parent }: PropsInterface) => {
  const dispatch      = useAppDispatch();
  const { pathname }  = useLocation();
  const activeItem    = Object.values(navs).find(e => e.url === pathname);
  const ids           = useAppSelector(selectCategoryIds);

  function onClickCreate() {
    dispatch(setNewParams({ target: 1 }));
  }

  function onClickSettings() {
    dispatch(setReorderIds({ ids }));
  }

  return (
    <PageHeader
      title={title}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={navs}
        itemIds={Object.keys(navs)}
        activeId={activeItem?.id}
        parent={parent}
      />

      <NavBarThree>
        <NavBarThree.Button onClick={onClickSettings}>
          <SettingOutlined /> Tag Settings
        </NavBarThree.Button>
        <NavBarThree.Button onClick={onClickCreate}>
          <PlusOutlined /> Create Tag
        </NavBarThree.Button>
      </NavBarThree>
    </PageHeader>
  );
}

export default _PageHeader;
